$(document).ready(function () {
    let width = undefined;
    let open = 0;
    let sidePanels = {};
    let availableSidePanels = {};
    window.bootstrapDatepickerConfig ??= {
        dateFormat: 'DD-MM-YYYY',
        weekStart: 1,
        ignoreReadonly: true,
        orientation: 'auto',
        forceParse: false,
        todayBtn: true,
        todayHighlight: true,
        clearBtn: true,
        language: document.getElementsByTagName('html')[0].getAttribute('lang'),
        format: {
            /*
             * Say our UI should display a week ahead,
             * but textbox should store the actual date.
             * This is useful if we need UI to select local dates,
             * but store in UTC
             */
            toDisplay: function (date, format, language) {
                return moment(date).format('DD-MM-YYYY');
            }, toValue: function (date, format, language) {
                return moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
            }
        }
    };

    window.tinyMceConfig ??= {
        forced_root_block: "",
        plugins: 'lists advlist link paste image code visualchars',
        toolbar: 'formatselect undo redo bullist numlist bold italic visualchars forecolor link image removeformat code alignleft aligncenter alignright',
        extended_valid_elements: '*[*]',
        menubar: false,
        width: '100%',
        paste_data_images: true,
        link_class_list: [{title: 'None', value: ''}, {
            title: 'Primary button',
            value: 'btn btn-primary btn-sm'
        }, {title: 'Success button', value: 'btn btn-success btn-sm'}],
        visualchars_default_state: false
    }
    window.tinyMceConfig.height = 'calc(100vh - 300px)';
    window.tinyMceConfig.setup = function (editor) {
        editor.on('keydown', function (evt) {
            if (evt.keyCode === 9) { // tab pressed
                editor.execCommand('mceInsertContent', false, '\x09'); // inserts tab
                evt.preventDefault();
                // evt.stopPropagation();
                return false;
            }
        });
    }

    // window.tinyMceConfig.setup = function (ed) {
    //     console.log(ed.onkeydown)
    //
    //     ed.on('keydown', function (evt) {
    //         console.log(evt.keyCode)
    //         if (evt.keyCode === 9) { // tab pressed
    //             // ed.execCommand('mceInsertRawHTML', false, '\x09'); // inserts tab
    //             // evt.preventDefault();
    //             // evt.stopPropagation();
    //             return false;
    //         }
    //     });
    // }

    if ($.fn.getFormDataAssociative === undefined || $.fn.fillFormErrors === undefined) {
        require('./jQuery.formData.extension');
    }

    /**
     * Init side panel
     *
     * @param _this
     */
    sidePanels.init = (_this) => {
        let sidePanel = $(_this);
        sidePanel.content = sidePanel.find('.side-panel-body');
        sidePanel.loaded = false;
        sidePanel.stopExecutionAfterFormEvent = false;
        sidePanel.refreshAlways = !!sidePanel.data().reload ?? true;
        sidePanel.route = sidePanel.mainRoute = sidePanel.data().route;
        sidePanel.childPanels = sidePanel.find('.child-panel-container');
        sidePanel.defaultTitle = null;

        /**
         * Close the panel.
         *
         * @param e
         */
        sidePanel.close = (e) => {
            sidePanel = sidePanels.getCurrentSidePanel();
            sidePanel.trigger('nc.sidePanel.hide', [sidePanel]);
            sidePanel.fadeOut(200);
            sidePanel.forgetTarget(open);
            sidePanel.trigger('nc.sidePanel.hidden', [sidePanel]);
            try {
                sidePanel.content.find('.tinymce').tinymce('destroy');
            } catch (e) {
            }
            sidePanel.content.find(['data-toggle^="#data-side"']).unbind();
            if (sidePanel.refreshAlways === true) {
                sidePanel.content.html('');
            }
        }

        /**
         * Reload the panel
         */
        sidePanel.reload = () => {
            sidePanel.loadURL(sidePanel.url)
        };

        /**
         * Load the content of the url in the panel.
         *
         * @param url
         */
        sidePanel.loadURL = (url) => {
            loadUrl(sidePanel, url)
        }

        /**
         * Get the title of the panel.
         *
         * @return html|null
         */
        sidePanel.getTitle = () => {
            let titleElement = sidePanel.find('.side-panel-title');
            if (titleElement.length > 0) {
                return titleElement.html();
            }
            return null;
        }

        /**
         *  Set the title op the panel.
         *
         * @param html html or text allowed.
         */
        sidePanel.setTitle = (html) => {
            let titleElement = sidePanel.find('.side-panel-title');
            if (titleElement.length > 0) {
                titleElement.html(html);
            }
        }

        // Set the title given initially as the default title.
        sidePanel.defaultTitle = sidePanel.getTitle();

        registerMethods(sidePanel);
        registerEvents(sidePanel);
        registerLoader(sidePanel);
        availableSidePanels[sidePanel.id] = sidePanel;
    }

    /**
     *
     * @returns {*[]}
     */
    sidePanels.getSidePanels = () => {
        let panels = []
        for (let k in window.sidePanels) {
            if (window.sidePanels.hasOwnProperty(k) && typeof window.sidePanels[k] === 'object') {
                panels[k] = window.sidePanels[k];
            }
        }

        return panels;
    }

    /**
     *
     * @param elem
     * @param route
     * @param target
     */
    sidePanels.open = (elem = $, route = null, target = $) => {
        if (!elem.is('[id^="data-side-panel-"]')) {
            throw new Error('The given element is not a valid side panel.')
        }

        let sidePanel = availableSidePanels[elem.id];
        if (route) sidePanel.route = route;

        openSidePanel(sidePanel, target);
    }

    /**
     *
     * @returns {*}
     */
    sidePanels.getCurrentSidePanel = () => {
        return window.sidePanels.getSidePanels().reverse()[0];
    }

    window.sidePanels = sidePanels;
    // window.sidePanels.init = sidePanels.init()

    /** Register all sidePanels available in DOM */
    $('[id^="data-side-panel-"]').each(function (k, i) {
        sidePanels.init(i);
    });

    /**
     *
     * @param sidePanel
     */
    function registerMethods(sidePanel) {
        /** Targets */
        sidePanel.registerTarget = (target) => {
            sidePanel.target = target
            let exists = false;
            let currentSidePanels = sidePanels.getSidePanels();

            if (currentSidePanels.length) {
                for (let k in currentSidePanels) {
                    if (exists === false && currentSidePanels.hasOwnProperty(k)) {
                        if (currentSidePanels[k][0].id === sidePanel[0].id) {
                            exists = true;
                            break;
                        }
                    }
                }
            }

            if (exists) {
                open--
                delete sidePanels[open];
            }

            sidePanels[open] = sidePanel;
            window.sidePanels = sidePanels;
            open = sidePanels.getSidePanels().length
        }

        /**
         *
         *
         */
        sidePanel.forgetTarget = () => {
            delete sidePanels[(open - 1)];
            window.sidePanels = sidePanels;
            open = sidePanels.getSidePanels().length
        }
    }

    /**
     *
     * @param sidePanel
     */
    function registerEvents(sidePanel) {
        /** Open side panel */
        $(document).on('click', '[data-toggle="#' + sidePanel[0].id + '"]:not(.disabled)', (e) => {
            let item = $(e.target)

            if (item.not('[data-toggle="#' + sidePanel[0].id + '"]')) {
                item = item.closest('[data-toggle="#' + sidePanel[0].id + '"]');
            }

            if (item.data().route !== undefined && item.data().route.length) {
                sidePanel.route = item.data().route;
            } else {
                sidePanel.route = sidePanel.mainRoute;
            }

            // If the caller has the data-title attribute, use it as the title for the panel.
            if (item.data().title !== undefined && item.data().title.length) {
                sidePanel.setTitle(item.data().title);
            } else {
                // No data-title attribute, change the title of the panel (back) to the default.
                sidePanel.setTitle(sidePanel.defaultTitle);
            }

            openSidePanel(sidePanel, item);
        });

        /** Close side panel */
        sidePanel.before().mousedown((e) => {
            e.target.id === sidePanel[0].id ? sidePanel.close() : '';
        });
        sidePanel.find('.side-panel-close').click(() => {
            sidePanel.close();
        });
    }

    /**
     *
     * @param sidePanel
     * @param target
     */
    function openSidePanel(sidePanel, target) {
        if (sidePanel.loaded === false || sidePanel.refreshAlways === true) {
            sidePanel.trigger('nc.sidePanel.show', [sidePanel]);
            if (sidePanel.route.length) {
                sidePanel.loader.open();
                sidePanel.url = sidePanel.route;
                sidePanel.content.load(sidePanel.route, null, function () {
                    sidePanel.loader.close();

                    registerLinks(sidePanel);
                    registerForm(sidePanel);
                    registerSortableTables();
                    initializeJsComponents(sidePanel)
                    sidePanel.loaded = true;
                    sidePanel.trigger('nc.sidePanel.shown', [sidePanel]);
                })
            } else {
                registerLinks(sidePanel);
                registerForm(sidePanel);
                registerSortableTables();
                sidePanel.loaded = true;
                sidePanel.trigger('nc.sidePanel.shown', [sidePanel]);
                initializeJsComponents(sidePanel)
            }
        }

        sidePanel.registerTarget(target)
        sidePanel.fadeIn(200);


        if (width === undefined) {
            width = (100 / document.documentElement.clientWidth) * sidePanel.width();
        }

        if (window.sidebars !== undefined) {
            /** TODO: remove when sidebars are totally removed from pub */
            let openTotalPub = (open + window.sidebars.getSidebars().length);
            sidePanel.css('width', (width - (3 * (openTotalPub - 1))) + '%');
            sidePanel.css('z-index', 2000 + (openTotalPub - 1));
        } else {
            sidePanel.css('width', (width - (3 * (open - 1))) + '%');
        }
    }

    /**
     *
     * @param sidePanel
     */
    function registerLinks(sidePanel) {
        /** Follow links */
        sidePanel.content.find('a[target!="_blank"]:not(.cancelForm):not(.follow)').click((e) => {
            e.preventDefault();
            sidePanel.loader.open();
            sidePanel.trigger('nc.sidePanel.reload', [sidePanel]);
            if (!$(e.target).is('a')) {
                e.target = $(e.target).closest('a')[0];
            }
            loadUrl(sidePanel, e.target.href);
        });
    }

    /**
     *
     * @param sidePanel
     * @param url
     */
    function loadUrl(sidePanel, url) {
        sidePanel.content.load(url, null, () => {
            registerLinks(sidePanel);
            registerForm(sidePanel);
            registerSortableTables();
            initializeJsComponents(sidePanel)
            sidePanel.loader.close();
            sidePanel.trigger('nc.sidePanel.reloaded', [sidePanel]);
            sidePanel.url = url;
        });
    }

    /**
     *
     * @param sidePanel
     */
    function registerForm(sidePanel) {
        /** Register form */
        sidePanel.form = sidePanel.content.find('form:not(.disabled)');

        /** Form handling */
        sidePanel.form.each((k, form) => {
            $(form).submit((e) => {
                e.preventDefault();
                sidePanel.loader.open();
                setTimeout(() => {
                    $.post({
                        url: e.target.action,
                        dataType: 'JSON',
                        processData: false,
                        contentType: false,
                        data: $(form).getFormDataAssociative(),
                        success: (result) => {
                            // check if event listener 'nc.sidePanel.formSuccess' is attached to the current sidePanel
                            if ($(form).closest('[id^="data-side-panel-"]').is(sidePanel)) {
                                sidePanel.trigger('nc.sidePanel.formSuccess', [result, form, sidePanel]);
                                if (sidePanel.hasListeners('nc.sidePanel.formSuccess')
                                    && sidePanel.stopExecutionAfterFormEvent === true) {
                                    sidePanel.stopExecutionAfterFormEvent = false;
                                    return;
                                }
                            }

                            if (result.route !== undefined && result.route.length) {
                                sidePanel.loadURL(result.route);
                            }

                            if (result.routeReloadPage !== undefined && result.routeReloadPage.length) {
                                window.location.href = result.routeReloadPage;
                            }
                        },
                        error: (error) => {
                            sidePanel.trigger('nc.sidePanel.formError', [error, form, sidePanel]);
                            if (sidePanel.hasListeners('nc.sidePanel.formError')
                                && sidePanel.stopExecutionAfterFormEvent === true) {
                                sidePanel.stopExecutionAfterFormEvent = false;
                                return;
                            }
                            if (error.status === 422) {
                                $(form).fillFormErrors(error.responseJSON.errors)
                            }
                        },
                        complete: () => {
                            sidePanel.loader.close();
                        }
                    });
                });
            })
        })
    }

    $.fn.hasListeners = function (eventName) {
        const events = $._data(this[0], 'events');
        let eventNamespace = false;

        // check if event namespaced
        if (eventName.indexOf('.') !== -1) {
            eventNamespace = eventName.split('.');
            eventName = eventName.split('.')[0];
            eventNamespace.reverse().pop();
            eventNamespace = eventNamespace.join('.');
        }

        if (events.length == 0 || events[eventName] === undefined) {
            return false;
        }

        if (!eventNamespace) {
            return true;
        }

        for (const event of events[eventName]) {
            if (event.namespace === eventNamespace) {
                return true;
            }
        }

        return false;
    }

    /**
     *
     * @param sidePanel
     */
    function registerLoader(sidePanel) {
        sidePanel.loader = sidePanel.find('.side-panel-loader');

        /** Open */
        sidePanel.loader.open = () => {
            sidePanel.trigger('nc.sidePanel.loader.show', [sidePanel]);
            sidePanel.loader.fadeIn(200);
            sidePanel.trigger('nc.sidePanel.loader.shown', [sidePanel]);
        }

        /** Close */
        sidePanel.loader.close = () => {
            sidePanel.trigger('nc.sidePanel.loader.hide', [sidePanel]);
            sidePanel.loader.fadeOut(150);
            sidePanel.trigger('nc.sidePanel.loader.hidden', [sidePanel]);
        }
    }

    /**
     *
     */
    function registerSortableTables() {
        if (window.hasOwnProperty('createSortableTables')) {
            window.createSortableTables();
        }
    }

    /**
     *
     * @param sidePanel
     */
    function initializeJsComponents(sidePanel) {
        sidePanel.content.find('[data-toggle="tooltip"]').tooltip()
        sidePanel.content.find('.selectpicker').selectpicker();
        sidePanel.content.find('.datepicker').datepicker(bootstrapDatepickerConfig);

        try {
            sidePanel.content.find('.tinymce').each(function () {
                if ($(this).hasClass('tinymce-sm')) {
                    tinyMceConfig.height = '250px';
                    $(this).tinymce(tinyMceConfig);
                    return;
                }
                $(this).tinymce(tinyMceConfig);
            });
        } catch (e) {
            // console.log(e);
        }
        sidePanel.childPanels.html('');
        sidePanel.content.find('[id^=data-side-panel-]').each(function (k, i) {
            $(i).detach().appendTo(sidePanel.childPanels);
            sidePanels.init(i);
        });
    }

});
